import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AccountSession } from '../account.type';

@Component({
  selector: 'app-account-session-info',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './account-session-info.html',
  styleUrl: './account-session-info.scss'
})
export class AccountSessionInfo {
  readonly dialogRef = inject(MatDialogRef<AccountSessionInfo>);
  readonly data = inject<{ account: AccountSession }>(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }

  getFormattedDate(date: Date): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString();
  }

  copyToClipboard(text: string) {
    const inp = document.createElement('input');
    document.body.appendChild(inp);
    inp.value = text;
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
  }
}
